'use es6';

export function getGlobalWidgetNameFromLabel(label) {
  return label.replace(/\s/g, '_').replace(/[^a-zA-Z0-9_]/g, '').toLowerCase();
}